/* =============================================================
 * dopa-gift-flow.js
 * Inject banner "Đổi size miễn phí cho quà tặng" vào cart
 * khi khách có intent = 'gift' HOẶC khi cart có gift item
 * (_gift_bundle property từ dopa-bundle-gift.js).
 *
 * Target selectors (thêm / điều chỉnh nếu theme khác):
 *   Cart drawer: .cart-drawer__footer, .cart__footer
 *   Cart page  : .cart__items, form[action="/cart"]
 * ============================================================= */

(function () {
  'use strict';

  var BANNER_ID   = 'dopa-gift-banner';
  var GIFT_PROP   = '_gift_bundle';        // từ dopa-bundle-gift.js
  var INTENT_KEY  = 'dopa_purchase_intent';

  /* ── Helpers ─────────────────────────────────────────────── */
  function getIntent() {
    try { return localStorage.getItem(INTENT_KEY) || null; } catch (e) { return null; }
  }

  function cartHasGift(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(function (item) {
      var props = item.properties || {};
      return !!props[GIFT_PROP];
    });
  }

  /* ── Banner DOM ──────────────────────────────────────────── */
  function createBanner() {
    var div = document.createElement('div');
    div.id = BANNER_ID;
    div.className = 'dopa-gift-banner';
    div.setAttribute('role', 'note');
    div.innerHTML =
      '<span class="dopa-gift-banner__icon">🎀</span>' +
      '<span class="dopa-gift-banner__text">' +
        '<strong>Quà tặng — đổi size miễn phí 30 ngày.</strong> ' +
        'Người nhận mặc không vừa? Nhắn dope 🔥, dope 🔥 đổi ngay — không cần lý do.' +
      '</span>';
    return div;
  }

  function removeBanner() {
    var existing = document.getElementById(BANNER_ID);
    if (existing) existing.parentNode.removeChild(existing);
  }

  /* ── Inject into cart ────────────────────────────────────── */
  function injectBanner() {
    if (document.getElementById(BANNER_ID)) return; // Already there

    var banner = createBanner();

    // Try cart drawer first, then cart page
    var targets = [
      document.querySelector('.cart-drawer__footer'),
      document.querySelector('.cart__footer'),
      document.querySelector('.cart-drawer [data-cart-footer]'),
      document.querySelector('form[action="/cart"] .cart__items'),
      document.querySelector('.cart-items'),
    ];

    for (var i = 0; i < targets.length; i++) {
      if (targets[i]) {
        targets[i].insertAdjacentElement('afterbegin', banner);
        return;
      }
    }

    // Fallback: before the checkout button
    var checkoutBtns = document.querySelectorAll('[name="checkout"], a[href="/checkout"], .cart__checkout-button');
    if (checkoutBtns.length) {
      checkoutBtns[0].parentNode.insertBefore(banner, checkoutBtns[0]);
    }
  }

  /* ── Decide whether to show ──────────────────────────────── */
  function evaluate(cart) {
    var intent  = getIntent();
    var hasGift = cartHasGift(cart);

    if (intent === 'gift' || hasGift) {
      injectBanner();
    } else {
      removeBanner();
    }
  }

  /* ── Fetch cart and evaluate ─────────────────────────────── */
  function check() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(evaluate)
      .catch(function () {
        // Fallback: just check intent
        if (getIntent() === 'gift') injectBanner();
      });
  }

  /* ── Events ──────────────────────────────────────────────── */
  function bind() {
    // Cart changes
    document.addEventListener('cart:updated',    check, { passive: true });
    document.addEventListener('cart:item-added', check, { passive: true });
    document.addEventListener('cart:refresh',    check, { passive: true });

    // When intent changes
    document.addEventListener('dopa:intent_updated', function (e) {
      if (e.detail && e.detail.intent === 'gift') {
        check();
      } else {
        // Re-check with cart — maybe still has gift item
        check();
      }
    });

    // Cart drawer open
    document.addEventListener('cart-drawer:open', function () {
      setTimeout(check, 150); // Wait for drawer DOM
    });
    document.addEventListener('drawer:open', function () {
      setTimeout(check, 150);
    });
  }

  /* ── Init ────────────────────────────────────────────────── */
  function init() {
    bind();
    // Initial check
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
